export const init = () => {
  if (document.querySelector('.js-circle') && document.querySelector('.js-s-mia-chatbox__part')) {
    console.log("started");
    const circle = document.querySelector('.js-circle');
    let lastX;
    let lastY;

    document.querySelector('.js-s-mia-chatbox__part').addEventListener('mousemove', (e) => {
      var xPos = e.pageX;
      var yPos = e.pageY;

      lastX = xPos;
      lastY = yPos;

      if (e.target.localName == "iframe") {
        circle.style.cssText = `transform: translateY(${yPos - 140 - 275
          }px) translateX(${xPos - 326 - 275
          }px); opacity: 0;`
      } else {
        circle.style.cssText = `transform: translateY(${yPos - 140 - 275
          }px) translateX(${xPos - 326 - 275
          }px); opacity: 1;`
      }


    })

    document.querySelector('.js-s-mia-chatbox__part').addEventListener('mouseleave', (e) => {
      circle.style.cssText = `transform: translateY(${lastY - 140 - 275
        }px) translateX(${lastX - 326 - 275
        }px); opacity: 0;`
    })
  }
}